import { Button, Link, Text } from "north.js";
import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import styled from "styled-components";

import { Icon } from "src/shared/components";

import { formatTime } from "../../shared/utils/date";
import { TCheckInResult, TShift } from "../constants";

interface MixedResultBottomSheetProps {
  shifts: TShift[];
  shiftResults: TCheckInResult[];
  isOpen: boolean;
  onScanAnother: () => void;
  onClose: () => void;
}
const MixedResultBottomSheet: React.FC<MixedResultBottomSheetProps> = ({
  isOpen,
  shifts,
  shiftResults,
  onScanAnother,
  onClose,
}) => {
  return (
    <StyledBottomSheet open={isOpen} onDismiss={onClose}>
      <ModalWrapper>
        {shifts.map((shift, index) => (
          <>
            <ShiftWrapper>
              <ShiftInfo>
                <Text type="h3">Shift: {shift.name}</Text>
                <Text>
                  {formatTime(shift.startTime) +
                    " - " +
                    formatTime(shift.displayEndTime ?? shift.endTime)}
                </Text>
                {!shiftResults[index].success && (
                  <ErrorMessage>
                    {shiftResults[index].error?.message}
                  </ErrorMessage>
                )}
              </ShiftInfo>
              <Icon
                name={
                  shiftResults[index].success
                    ? "check-circle-inverted-green"
                    : shiftResults[index].error?.message ===
                      "Already checked in."
                    ? "check-circle-inverted"
                    : "check-circle-inverted-red"
                }
                size={
                  shiftResults[index].error?.message !==
                    "Already checked in." && !shiftResults[index].success
                    ? "40px"
                    : "48px"
                }
              />
            </ShiftWrapper>
          </>
        ))}
        <ModalButtons>
          <ScanningButton color="primary" size="md" onClick={onScanAnother}>
            Scan another QR code ➜
          </ScanningButton>
          <Link onClick={onClose}>Close</Link>
        </ModalButtons>
      </ModalWrapper>
    </StyledBottomSheet>
  );
};

const StyledBottomSheet = styled(BottomSheet)`
  position: fixed;
  z-index: 10000 !important;
`;

const ModalWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 24px;
  gap: 14px;
`;

const ShiftWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const ShiftInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 4px;
`;

const ErrorMessage = styled(Text)`
  color: ${({ theme }) => theme.globalConstants.color.textDanger};
`;

const ModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  margin-top: 18px;
`;

const ScanningButton = styled(Button)`
  --buttonWidth: 250px;
  width: 100% !important;
  max-width: var(--buttonWidth) !important;
  left: calc(50vw - var(--buttonWidth) / 2);
  height: 42px !important;
  * button {
    color: #43afde !important;
  }
`;

export default MixedResultBottomSheet;
